/**
 * Checks if the booking object is valid.
 * @param booking booking
 * @return {boolean} true if valid, false otherwise
 */
export function isValidBooking(booking) {
    return (
        booking?.venueId &&
        booking?.timeslotId &&
        booking?.firstName &&
        booking?.lastName &&
        booking?.phone &&
        booking?.email
    );
}
